<template>
  <h1>
    <span @click="$router.go(-1)"></span>
    <button :class="{'active': active === 'preview'}" @click="onClickGo('preview')">UT 미리보기</button>
    <button :class="{'active': active === 'visit'}" @click="onClickGo('visit')">UT 방문통계</button>
    <button :class="{'active': active === 'status'}" @click="onClickGo('status')">UT 결과통계</button>
  </h1>
</template>

<script>
export default {
  name: 'ResultMenu',
  props: [
    'active',
    'utid'
  ],
  methods: {
    onClickGo (name) {
      this.$router.replace({ name: 'result_' + name, params: { utid: this.utid } })
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  width: 990px;
  font-size: 20px;
  font-weight: 500;
  color: #2f2f2f;
  margin: 0 auto;

  & span {
    display: inline-block;
    width: 32px;
    height: 32px;
    vertical-align: top;
    border-radius: 5px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
    background: #fff url('../../assets/images/icon-page-back.svg') no-repeat center;
    margin-right: 30px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      background: #f7f7f7 url('../../assets/images/icon-page-back.svg') no-repeat center;
    }
  }

  & > button {
    display: inline-block;
    margin: 0px 40px 0 0;
    padding-bottom: 8px;
    color: #999;
    vertical-align: top;
    cursor: pointer;

    &.active {
      border-bottom: 3px solid #ec0047;
      color: #2f2f2f;
      cursor: pointer;
    }
  }
}
</style>
